export const tiny = '8px';
export const small = '16px';
export const base = '24px';
export const M = '32px';
export const XL = '40px';
export const XXL = '64px';

export default {
  tiny,
  small,
  base,
  M,
  XL,
  XXL,
};
